import React, { useRef, useState } from "react";
import "./index.less";
import { useNavigate } from "react-router-dom";

const BottomPage = () => {
  const ContacData = {
    list: [
      {
        title: "Products",
        list: [
          { title: "AI Computing Services", path: "/product?id=services" },
          { title: "Blockchain Computing", path: "/product?id=services" },
          { title: "Scientific Research", path: "/product?id=services" },
        ],
      },
      {
        title: "Services",
        list: [
          { title: "Core Advanta", path: "/product?id=advanta" },
          { title: "Technology Edge", path: "/product?id=technical" },
        ],
      },
      {
        title: "Industries",
        list: [
          { title: "Artificial Intelligence", path: "/industries?id=artificial" },
          { title: "Blockchain Technology ", path: "/industries?id=blockchain" },
          { title: "Scientific Research", path: "/industries?id=scientific" },
          { title: "Gaming and Entertainment", path: "/industries?id=gaming" },
          { title: "Finance and Fintech ", path: "/industries?id=finance" },
        ],
      },
      {
        title: "Advantages",
        list: [
          { title: "Key Advantages", path: "/industries?id=key" },
          { title: "Technical Highlights ", path: "/industries?id=technical" },
          { title: "Industries at a Glance", path: "/industries?id=glance" },
        ],
      },
      {
        title: "About",
        list: [
          { title: "Who We Are", path: "/contact?id=who" },
          { title: "Core Values", path: "/contact?id=core" },
          { title: "Contact Us", path: "/contact?id=contactUs" },
        ],
      },
    ],
  };
  const { content = "", btnUrl = "", list = [] } = ContacData;
  const navigate = useNavigate()
  const linkChange=(path)=>{
    const newPath = path.slice(0,path.indexOf('?'))
    console.log(newPath)
    navigate(newPath+'?id=1')
    setTimeout(() => {
      navigate(path)
    }, 0);
  }
  return (
    <div className="contact_warp">
      <div className="contact_box">
        <div className="right">
          {list.map((val) => {
            return (
              <div className="contact_item">
                <div className="title">{val.title}</div>
                <div className="content">
                  {val.list.map((data) => {
                    return <div onClick={()=>linkChange(data.path)}>{data.title}</div>;
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BottomPage;
